import { Outlet } from "react-router-dom";
import styles from "@/styles/layout.module.css";
import { layoutBackgrounds } from "@/assets";

export default function PrivacyPolicyLayoutRoute() {
  return (
    <div className={styles.homeLayout} style={layoutBackgrounds.home}>
      <main>
        <Outlet />
      </main>
    </div>
  );
}
